import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, Loader2, Trash2, MessageSquare, BadgeCheck } from "lucide-react";
import api from "../../services/api";
import { productPath } from "../../utils/links";

const ReviewsSection = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/account/reviews").then(({ data }) => setReviews(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const remove = async (id) => {
    if (!window.confirm("Supprimer cet avis ?")) return;
    try { await api.delete(`/reviews/${id}`); setReviews((l) => l.filter((r) => r.id !== id)); } catch { /* noop */ }
  };

  if (loading) return <div className="flex justify-center py-16"><Loader2 className="animate-spin text-[#FF3B3B]" size={32} /></div>;

  return (
    <div data-testid="account-reviews">
      <h1 className="font-extrabold italic uppercase tracking-tight text-slate-50 text-2xl md:text-3xl flex items-center gap-2 mb-5"><MessageSquare size={26} className="text-[#FF3B3B]" /> Mes avis</h1>
      {reviews.length === 0 ? (
        <div className="bg-[#10131A] rounded-2xl border border-[#1E232D] p-12 text-center text-slate-400">
          <Star size={40} className="text-slate-500 mx-auto mb-3" />
          Vous n'avez pas encore publié d'avis. Rendez-vous sur la fiche d'un produit pour partager votre expérience.
        </div>
      ) : (
        <div className="space-y-3">
          {reviews.map((r) => (
            <div key={r.id} data-testid={`my-review-${r.id}`} className="bg-[#10131A] rounded-2xl border border-[#1E232D] p-5">
              <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
                <Link to={productPath(r.product_id)} className="font-bold text-slate-50 hover:text-[#FF3B3B] transition-colors">{r.product_name}</Link>
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-0.5">{[1, 2, 3, 4, 5].map((n) => <Star key={n} size={14} className={n <= r.rating ? "fill-[#f5a623] text-[#f5a623]" : "text-slate-700"} />)}</div>
                  <button data-testid={`my-review-delete-${r.id}`} onClick={() => remove(r.id)} className="text-slate-500 hover:text-red-500 transition-colors" title="Supprimer"><Trash2 size={16} /></button>
                </div>
              </div>
              <div className="text-[12px] text-slate-500 mb-1 flex items-center gap-2">{new Date(r.created_at).toLocaleDateString("fr-FR")}{r.verified && <span className="inline-flex items-center gap-1 text-emerald-400"><BadgeCheck size={12} /> Achat vérifié</span>}</div>
              {r.title && <div className="font-semibold text-slate-100">{r.title}</div>}
              <p className="text-slate-300 text-[14px] leading-relaxed">{r.comment}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReviewsSection;
